import { render } from "./v-alert.vue?vue&type=template&id=1d3c8772"
import script from "./v-alert.vue?vue&type=script&lang=js"
export * from "./v-alert.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__